const AnonCategories = [
  {
    category: "General",
    value: 9,
  },
  { category: "Films", value: 11 },
  { category: "Science", value: 17 },
  { category: "Sports", value: 21 },
  { category: "History", value: 23 },
  { category: "Computers", value: 18 },
];

export default AnonCategories;
